import { getScrollContainer, getScrollY } from './utils/scroll-container';

const SCROLL_THRESHOLD = 100;
const SCROLL_DURATION = 600;
const SCROLL_BUTTON_SELECTOR = '.js-scroll-top';

const scrollToTop = (): void => {
  const container = getScrollContainer();
  
  if (container instanceof HTMLElement) {
    container.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  
  // Focus management for accessibility after scroll completes
  setTimeout(() => {
    const body = document.body;
    body.setAttribute('tabindex', '-1');
    body.focus();
  }, SCROLL_DURATION);
};

const handleScrollButtonClick = (event: Event): void => {
  event.preventDefault();
  scrollToTop();
};

const handleScroll = (): void => {
  const scrollButton = document.querySelector<HTMLElement>(SCROLL_BUTTON_SELECTOR);
  if (!scrollButton) return;
  
  const container = getScrollContainer();
  const scrollY = getScrollY(container);
  
  if (scrollY > SCROLL_THRESHOLD) {
    scrollButton.classList.add('is-active');
  } else {
    scrollButton.classList.remove('is-active');
  }
};

const setupScrollListener = (): void => {
  let ticking = false;
  
  const throttledScrollHandler = (): void => {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  };
  
  const container = getScrollContainer();
  container.addEventListener('scroll', throttledScrollHandler, { passive: true });
};

const setupClickListeners = (): void => {
  const scrollButtons = document.querySelectorAll<HTMLElement>(SCROLL_BUTTON_SELECTOR);
  
  scrollButtons.forEach((button) => {
    button.addEventListener('click', handleScrollButtonClick);
  });
};

const init = (): void => {
  setupScrollListener();
  setupClickListeners();
};

export { init };
